import { useQuery } from "@tanstack/react-query";
import apiService from "../services/api";
import { GetPatientsIntakePayload, GetPatientsTasksPayload, GetInternalTasksPayload } from "../types/api";

export const useClinics = (token: string) => {
  return useQuery({
    queryKey: ["clinics", token],
    queryFn: () => apiService.getClinics(token),
    enabled: !!token,
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnWindowFocus: true,
  });
};


export const usePatientIntakePaging = (payload: GetPatientsIntakePayload) => {
  return useQuery({
    queryKey: [
      "patientIntakePaging",
      payload.clinic_id,
      payload.offset,
      payload.pageSize,
      payload.search,
      payload.status,
      payload.user_id,
      payload.sortedBy,
    ],
    queryFn: () => apiService.getPatientsIntakePaging(payload),
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnWindowFocus: true,
  });
};

export const useUsers = (payload: { token: string; user_type: string; institution_id: number }) => {
  return useQuery({
    queryKey: ["users", payload.user_type, payload.institution_id],
    queryFn: () => apiService.getUsers(payload),
    enabled: !!payload.token && payload.institution_id > 0,
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnWindowFocus: true,
  });
};

export const usePatientsTasks = (payload: GetPatientsTasksPayload) => {
  return useQuery({
    queryKey: ["patientsTasks", payload.clinic_id],
    queryFn: () => apiService.getPatientsTasks(payload),
    enabled: !!payload.token,
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnWindowFocus: true,
  });
};

export const useInternalTasks = (payload: GetInternalTasksPayload) => {
  return useQuery({
    queryKey: ["internalTasks", payload.clinic_id, payload.patient_id, payload.user_id],
    queryFn: () => apiService.getInternalTasks(payload),
    enabled: !!payload.token,
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnWindowFocus: true,
  });
};
